import PropTypes from 'prop-types';
import React from 'react';
import { Image } from 'react-bootstrap';
import Avatar from 'react-avatar';
import moment from 'moment';
import { Button } from 'react-bootstrap/lib/InputGroup';
import UploadFormModal from '../../tours/components/UploadFormModal ';
// import UploadFormModal from '../../tours/components/UploadFormModal';



function renderImage(src, name) {
  if (src) {
    return (
      <Image src={src} responsive className="avatar" />
    );
  }
  return (
    <Avatar name={name} color="#326a34" size={75} className="avatar" />
  );
}

class TourHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      show: false,
      uploadFlag: false,
      groupFormpopup: false,
    }
  }
  tourDate() {
    const start = moment(this.props.tour.start);
    const end = moment(this.props.tour.end);
    if (start.isValid()) {
      return `${start.format('MMMM Do YYYY')} - ${end.format('MMMM Do YYYY')}`;
    }
    return '';
  }
  handleGroupModel = () => {
    this.setState({
      groupFormpopup: true,
    });
  }
  closeModal=() =>{
    console.log("this is close method called")
    this.setState({
      show: false,
      groupFormpopup: false,
    });
  }

  render() {
    const image = renderImage(this.props.tour.image, this.props.tour.name);
    // const tourDate = this.tourDate();
    let strTourManager = '';
    if (this.props.tour.primary_agent_profile) {
      strTourManager = this.props.tour.primary_agent_profile.first_name + ' ' + this.props.tour.primary_agent_profile.last_name
    }
    let contact_TourManager = '';
    if (this.props.tour.primary_agent_profile) {
      contact_TourManager = this.props.tour.primary_agent_profile.profile.mobile;
    }
    let email_TourManager = '';
    if (this.props.tour.primary_agent_profile) {
      email_TourManager = this.props.tour.primary_agent_profile.email;
    }
    let iata = '';
    if (this.props.tour.iata) {
      iata = this.props.tour.iata;
    }
    let group_name = '';
    if (this.props.tour.groups) {
      let grp = this.props.tour.groups;
      grp.map((group) => {
        group_name = group.name;
      });
    }

    return (
      <div className="tour-header">
        {image}
        <div className="tour-title">
          <h2>{this.props.tour.name}: <span>{this.props.tour.tag_line}</span></h2>
          <div className="tour-info">
            <div className="tour-date"> </div>
          </div>
          <div>
            <b>Group Name:&nbsp;</b>{group_name}
          </div>
          <div>
            <b>Travel Agent:&nbsp;</b>{strTourManager}
          </div>
          <div >
            <b>Contact:&nbsp;</b>{contact_TourManager}
          </div>
          <div >
            <b>Email:&nbsp;</b>{email_TourManager}
          </div>
        </div>
        <div className="col-sm-6">
          <div className="pull-right">
            <h2>{this.props.tour.travel_agency.name}</h2>
            <p>IATA# {iata}</p>
          </div>
          <Avatar
            name={this.props.tour.travel_agency.name}
            src={this.props.tour.travel_agency.logo}
            size={75}
            className="pull-right avatar"
          />
          <div className="clearfix" />
          {/* <div className='booking-groupBtn'>
                <div className='booking-uploadFormButton' >
                  <button className="booking-btn" onClick={this.handleGroupModel} >
                    <i className="fa fa-file-code-o" /> Manage Group Documents
                  </button>
                </div>
              </div> */}
        </div>
        {this.state.groupFormpopup && (
            <UploadFormModal
              upload_type={'Tour Group'}
              tour={this.props.tour}
              tourp={this.props.profilename}
              show={this.state.groupFormpopup}
              onClose={this.closeModal} />
          )}
      </div>
    );
  }
}


TourHeader.propTypes = {
  tour: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag_line: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    image: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    created_on: PropTypes.string,
    updated_on: PropTypes.string,
    sent_to_manager: PropTypes.string,
    travel_agency: PropTypes.number,
    groups: PropTypes.arrayOf(PropTypes.object).required,
    notes: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

TourHeader.defaultProps = {
  tour: {
    state: 'draft',
    start: null,
    end: null,
    image: 'https://www.whyy.org/img/ontour_logocrop.png',
  },
};

export default TourHeader;



// WEBPACK FOOTER //
// src/routes/booking/components/TourHeader.js